import { useTranslation } from 'react-i18next';
import { icons } from '@shared/static/icons';
import { Status, CountryFlag } from '@shared/ui/parts';
import { formatBalanceUi, FRACTION_DIGITS } from '@utils/balance-helpers';
import { formatCardNumber } from '@utils/helpers';
import { cardTypeLabels, binsLogo } from '@utils/static';

export default function CardDetailsMobileCell({ row }) {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <div className="cardsMobile__item-top">
          {icons[row.details?.bankName]}
          <div>
            <p>{formatCardNumber(row.details?.cardNumber)}</p>
            <div className="cardsMobile__item-logo secondary-text">
              <CountryFlag countryCode={binsLogo[row.details?.bank_id]} />
              {row.details?.bank_public_name}
            </div>
          </div>
        </div>
        <div className="cardsMobile__item-bottom">
          <p className="status status--inactive">
            {t(cardTypeLabels[row.type])}
          </p>
          {icons[row.details?.paymentMethod]}
        </div>
      </div>
      <div className="cardsMobile__item-details">
        <p className="fw-500">
          {formatBalanceUi(row.limit, row.currency, FRACTION_DIGITS.INTEGER)}
        </p>
        <p className="secondary-text">{row.owner?.name}</p>
        <Status data={row} type="cards" />
      </div>
    </>
  );
}
